import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_na83mkfjze: FaireBrandEntity = {
  token: "b_na83mkfjze",
  type: "brand",
  name: "Grizzly Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/ce8117744d87f0d7efadcd6d201a1c0c4d7447a4a11fbe88277cb62fc199874d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a257acf144aba33ad80d43ab7fc7b61434553783c7133646997d93ea264c4a8d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ce8117744d87f0d7efadcd6d201a1c0c4d7447a4a11fbe88277cb62fc199874d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a257acf144aba33ad80d43ab7fc7b61434553783c7133646997d93ea264c4a8d.jpeg",
  location: "Stevensville, MT, USA",
  minimumOrderDollars: 4,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "We created a snack that can be enjoyed all the time but is also perfect for days spent outside, hitting trails or slopes. We’ve always loved discovering uniquely alpine flavors, and we’re excited to share them in a snack you can feel good about. Passionate about holistic health, American agriculture, and the Mountain West, we created a product that embodies all these values. A nutritious snack on the go, without any unwanted additives - and sourced from family farms out west. \n\nWe’re happy to accommodate lower minimums for new partners. Please contact us to discuss your order!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.803Z",
    importedBy: "entity-db-cli",
  },
};
